import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import useAuthorization from './useAuthorization'
import QuadrantLoader from '../loaders/quadrant-loader/QuadrantLoader'
import AccessDeniedPage from '../../pages/access-denied/AccessDeniedPage'
import Routes from '../../constants/routes'

const AuthorizedRoute = ({ roles, children }) => {
    const { isAuthorized, isLoggedIn, loading } = useAuthorization(roles)
    const location = useLocation()

    if (loading) {
        return <QuadrantLoader />
    }

    if (isAuthorized) {
        return children
    } else if (isLoggedIn) {
        return <AccessDeniedPage />
    } else {
        return <Navigate to={Routes.LOGIN} state={{ from: location }} replace />
    }
}

export default AuthorizedRoute
